import React from "react";
import ClockInBlockedCard from "./index";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function ClockInBlockedCardExample() {
  const handleViewTimesheet = () => {
    console.log("Navigate to timesheet");
  };

  return (
    <div style={{ padding: "2rem", backgroundColor: "#ffffff", minHeight: "100vh" }}>
      <h2 className="heading-h3-semibold" style={{ marginBottom: "2rem" }}>
        Clock In Blocked Card - All Scenarios
      </h2>

      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {/* Scenario 1: Upcoming shift with View Timesheet and No clock in allowed with tooltip */}
        <ClockInBlockedCard
          mainHeading="Upcoming shift time on Jan 12, 2025"
          subHeading="9:00 AM - 5:00 PM"
          subText="local time"
          action1={{
            label: "View Timesheet",
            onClick: handleViewTimesheet,
            variant: "contained",
            color: "inherit-text",
            size: "medium",
            disabled: false,
          }}
          action2={{
            label: "No clock in allowed",
            onClick: () => {},
            disabled: true,
            endIcon: <InfoOutlinedIcon />,
            tooltip: {
              content:
                "You are only allowed to clock in once your shift timings starts. In case of you want changes to your shift, contact HR directly.",
              direction: "bottom",
            },
          }}
        />

        {/* Scenario 2: Out of office - Holiday */}
        <ClockInBlockedCard
          mainHeading="Out of office"
          subHeading="You are on holiday today"
          action2={{
            label: "No clock-in required",
            onClick: () => {},
            variant: "contained",
            color: "secondary",
            size: "medium",
            disabled: true,
          }}
        />

        {/* Scenario 3: Out of office - Leave */}
        <ClockInBlockedCard
          mainHeading="Out of office"
          subHeading="You are out on [Leave Type] leave."
          action2={{
            label: "No clock-in required",
            onClick: () => {},
            variant: "contained",
            color: "secondary",
            size: "medium",
            disabled: true,
          }}
        />
      </div>
    </div>
  );
}

export default ClockInBlockedCardExample;
